import {
  PAYMENT_METHODS_INDEX_REQUESTED,
  PAYMENT_METHODS_INDEX_SUCCESS,
  PAYMENT_METHODS_INDEX_FAILURE,

  PAYMENT_METHOD_CREATE_REQUESTED,
  PAYMENT_METHOD_CREATE_SUCCESS,
  PAYMENT_METHOD_CREATE_FAILURE,

  PAYMENT_METHOD_UPDATE_REQUESTED,
  PAYMENT_METHOD_UPDATE_SUCCESS,
  PAYMENT_METHOD_UPDATE_FAILURE,

  PAYMENT_METHOD_DELETE_REQUESTED,
  PAYMENT_METHOD_DELETE_SUCCESS,
  PAYMENT_METHOD_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  paymentMethods: [],
  errors: null
};

const paymentMethods = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case PAYMENT_METHODS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        paymentMethods: [],
        status: 'requesting',
        errors: null,
      });

    case PAYMENT_METHODS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        paymentMethods: action.payload.payment_methods,
        errors: null
      });

    case PAYMENT_METHODS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        paymentMethods: [],
        errors: 'error here'
      });

    case PAYMENT_METHOD_CREATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case PAYMENT_METHOD_CREATE_SUCCESS:
      newState.isUpdating = false;
      newState.paymentMethods.push(action.paymentMethod.paymentMethod);
      return newState;

    case PAYMENT_METHOD_CREATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to create payment method';
      return newState;

    case PAYMENT_METHOD_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case PAYMENT_METHOD_UPDATE_SUCCESS:
      newState.isUpdating = false;
      let toUpdate = newState.paymentMethods.findIndex(method => method.id === action.paymentMethod.paymentMethod.id);
      newState.paymentMethods[toUpdate] = action.paymentMethod.paymentMethod;
      return newState;

    case PAYMENT_METHOD_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to update payment method';
      return newState;


    case PAYMENT_METHOD_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.paymentMethods = newState.paymentMethods.filter(method => method.id !== action.paymentMethodId);
      newState.errors = null;
      return newState;

    case PAYMENT_METHOD_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case PAYMENT_METHOD_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to delete payment method';
      return newState;


    default:
      return state;
  }
}

export default paymentMethods;